import React from "react";

interface WizardStepLayoutProps {
  children: React.ReactNode;
  action: React.ReactNode;
}

/** Flex column shell so wizard actions stay pinned to the bottom of the step. */
const WizardStepLayout: React.FC<WizardStepLayoutProps> = ({
  children,
  action,
}) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      flex: 1,
      minHeight: "min(480px, 60vh)",
      minWidth: 0,
      width: "100%",
      overflowX: "hidden",
    }}
  >
    <div style={{ flex: 1, minWidth: 0, width: "100%" }}>{children}</div>
    <div style={{ marginTop: "auto", paddingTop: 16, width: "100%" }}>
      {action}
    </div>
  </div>
);

export default WizardStepLayout;
